import { OptionCard, StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";

const WizardStepCamectOutput = ({ outputs, pinSelected, setPinSelected, onNext, onBack, isLastStep }) => (
    <>
        <StepHeader
            title="Which output would you like to link the Camect to?"
            subtitle="The selected output will arm & disarm the Camect"
        />
        <StepBody>
            {outputs.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No outputs are available to link.
                </p>
            )}
            {outputs.map(output => (
                <OptionCard
                    key={output.Pin}
                    radio
                    title={output.pinName}
                    selected={pinSelected === output.Pin}
                    onClick={() => setPinSelected(output.Pin)}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={pinSelected == null}
            nextLabel={isLastStep ? "Link Camect" : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default WizardStepCamectOutput;
